import {
  CoreFlightsCfarOffersComponents,
  CORE_FLIGHTS_CFAR_NAME,
} from "@b2bportal/core-types";

import { default as CfarReturnFilterBanner } from "./CfarReturnFilterBanner.module.scss";
import { default as HtsAirCfarFintechMarketplaceProduct } from "./HtsAirCfarFintechMarketplaceProduct.module.scss";
import { default as HtsAirCfarHowItWorksDialog } from "./HtsAirCfarHowItWorksDialog.module.scss";

export const CORE_FLIGHTS_CFAR_OFFERS_STYLE_OVERRIDES = {
  [CORE_FLIGHTS_CFAR_NAME]: {
    [CoreFlightsCfarOffersComponents.CfarReturnFilterBanner]:
      CfarReturnFilterBanner,
    [CoreFlightsCfarOffersComponents.HtsAirCfarHowItWorksDialog]:
      HtsAirCfarHowItWorksDialog,
    [CoreFlightsCfarOffersComponents.HtsAirCfarFintechMarketplaceProduct]:
      HtsAirCfarFintechMarketplaceProduct,
  },
};
